import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
   campoLabel: {
      alignSelf: 'center',
      paddingRight: theme.spacing(1),
      wordWrap: 'break-word',
      minWidth: '100px',
      width: '150px',
      cursor: 'default',
      float: 'left'
   },

   contenedor: {
      display: 'flex',
      width: '100%'
   },
   campo: {
      boxSizing: 'border-box',
      float: 'right',
      width: '100%'
   }
}));
/**
 * Agrega un label en el lado derecho de un componente. Cualquier otra propiedad sera redireccionada al componente *dsComponent*
 */
function LabelDecorator({
   label,
   className,
   labelProps,
   classNameLabel,
   classNameChildrenContainer,
   children,
   childrenContainerProps,
   required,
   ...others
}) {
   const classes = useStyles();
   return (
      <div className={clsx(classes.contenedor, className)} {...others}>
         {label && (
            <Typography className={clsx(classes.campoLabel, classNameLabel)} {...labelProps}>
               {label}
               {required ? '*' : ''}:
            </Typography>
         )}
         <div
            className={clsx(classes.campo, classNameChildrenContainer)}
            {...childrenContainerProps}
         >
            {children}
         </div>
      </div>
   );
}
LabelDecorator.propTypes = {
   /**
    * Texto label a mostrar.
    */
   label: PropTypes.string,
   /**
    * Clase a asignar al contenedor principal del componente.
    */
   className: PropTypes.string,
   /**
    * Clase a asignar al label del componente.
    */
   classNameLabel: PropTypes.string,
   /**
    * Clase a asignar al contenedor de __children__.
    */
   classNameChildrenContainer: PropTypes.string
};
export default LabelDecorator;
